export default __webpack_public_path__ + "static/media/lock.879c3784.svg";